var heading_default = {
  "fontElementMap": "x0wT3",
  "elementSpacing": "Y8q87",
  "headerOne": "wkiBE Y8q87",
  "headerTwo": "LPvhg Y8q87",
  "headerThree": "UgO-f Y8q87",
  "headerFour": "_82zrE Y8q87",
  "headerFive": "S3BFn Y8q87",
  "headerSix": "_5L0jv Y8q87",
  "child": "Kc-rf"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
